import type { BillingItemType, ParsedBillingItem } from '../types/cartTypes';

export function getCartBillingItemAmount(
  billingItems: ParsedBillingItem[],
  type: BillingItemType,
): number | undefined {
  return billingItems.find((detail) => detail.type === type)?.value?.centAmount;
}
